var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import ts, { factory } from "typescript";
import { getPropertyType, PropertyType } from '../../graphql/typeAlias';
import { createFunctionalComponent, createJsxSelfClosingElement, createJsxAttribute } from '../../react-components/react-component-helper';
import { getProperties } from '../../entity/index';
import { MuiDtTableComponents, muiDataGrid } from '../../../definition/material-ui/table';
import { Formatter } from "../../../definition/context-types";
import { createNameSpaceImport, uniqueImports } from "../../../ast/imports";
import { GeneratorHelper } from "../helper";
import ReactIntlFormatter from "../../react-components/react-intl/intl-formatter";
import { createAst, findByCondition, removeElementFromAst, replaceElementsToAST } from "../../../../ast";
import { findVariableDeclarations } from "../../../ast/ast";
import { findWidgetParentNode } from "../../../ast/widgetDeclaration";
import { getListComponentName } from "../../entity/helper";
var MuiDataTableGenerator = /** @class */ (function () {
    function MuiDataTableGenerator(generationContext, entity, widgetContext) {
        this._imports = [];
        this._helper = new GeneratorHelper(generationContext, this._imports);
        this._context = generationContext;
        this._entity = entity;
        this._widgetContext = widgetContext;
        this._intlFormatter = new ReactIntlFormatter(generationContext, this._imports);
    }
    MuiDataTableGenerator.prototype.insertColumn = function (tablePosition, property, columnIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var alteredSource, sourceCode, ast, columnDeclarationArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alteredSource = '';
                        if (!this._widgetContext) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._widgetContext.getSourceCodeString(tablePosition)];
                    case 1:
                        sourceCode = _a.sent();
                        ast = createAst(sourceCode);
                        if (ast) {
                            columnDeclarationArray = this.getColumnsDeclaration(sourceCode, tablePosition);
                            if (columnDeclarationArray) {
                                ast = this.addNewColumn(columnDeclarationArray, property, ast, columnIndex);
                            }
                            alteredSource = this.printSourceCode(ast);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, alteredSource];
                }
            });
        });
    };
    MuiDataTableGenerator.prototype.deleteColumn = function (tablePosition, columnIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var alteredSource, sourceCode, ast, columnDeclarationArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alteredSource = '';
                        if (!this._widgetContext) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._widgetContext.getSourceCodeString(tablePosition)];
                    case 1:
                        sourceCode = _a.sent();
                        ast = createAst(sourceCode);
                        if (ast) {
                            columnDeclarationArray = this.getColumnsDeclaration(sourceCode, tablePosition);
                            if (columnDeclarationArray === null || columnDeclarationArray === void 0 ? void 0 : columnDeclarationArray.elements[columnIndex]) {
                                ast = removeElementFromAst(ast, columnDeclarationArray.elements[columnIndex].pos);
                            }
                            alteredSource = this.printSourceCode(ast);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, alteredSource];
                }
            });
        });
    };
    MuiDataTableGenerator.prototype.getColumnSourcePosition = function (tablePosition, columnIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var result, sourceCode, ast, columnDeclarationArray, renderHeaderPosition, valueFormatterPosition, columnPosition, renderHeader, valueFormatter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._widgetContext) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._widgetContext.getSourceCodeString(tablePosition)];
                    case 1:
                        sourceCode = _a.sent();
                        ast = createAst(sourceCode);
                        if (ast) {
                            columnDeclarationArray = this.getColumnsDeclaration(sourceCode, tablePosition);
                            if (columnDeclarationArray === null || columnDeclarationArray === void 0 ? void 0 : columnDeclarationArray.elements[columnIndex]) {
                                renderHeaderPosition = void 0, valueFormatterPosition = void 0;
                                columnPosition = ast.getLineAndCharacterOfPosition(columnDeclarationArray.elements[columnIndex].getStart());
                                renderHeader = findByCondition(columnDeclarationArray.elements[columnIndex], function (node) {
                                    if (ts.isPropertyAssignment(node)) {
                                        if (ts.isIdentifier(node.name)) {
                                            return node.name.escapedText === 'renderHeader';
                                        }
                                    }
                                    return false;
                                });
                                valueFormatter = findByCondition(columnDeclarationArray.elements[columnIndex], function (node) {
                                    if (ts.isPropertyAssignment(node)) {
                                        if (ts.isIdentifier(node.name)) {
                                            return node.name.escapedText === 'valueFormatter';
                                        }
                                    }
                                    return false;
                                });
                                if (renderHeader) {
                                    renderHeaderPosition = ast.getLineAndCharacterOfPosition(renderHeader.getStart());
                                }
                                if (valueFormatter) {
                                    valueFormatterPosition = ast.getLineAndCharacterOfPosition(valueFormatter.getStart());
                                }
                                result = {
                                    columnPosition: {
                                        fileName: tablePosition.fileName,
                                        columnNumber: columnPosition.character + 1,
                                        lineNumber: columnPosition.line + 1,
                                        length: columnDeclarationArray.elements[columnIndex].getText().length
                                    },
                                    headerPosition: renderHeader && renderHeaderPosition ? {
                                        fileName: tablePosition.fileName,
                                        columnNumber: renderHeaderPosition.character + 1,
                                        lineNumber: renderHeaderPosition.line + 1,
                                        length: renderHeader.getText().length
                                    } : undefined,
                                    valuePosition: valueFormatter && valueFormatterPosition ? {
                                        fileName: tablePosition.fileName,
                                        columnNumber: valueFormatterPosition.character + 1,
                                        lineNumber: valueFormatterPosition.line + 1,
                                        length: valueFormatter.getText().length
                                    } : undefined
                                };
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, result];
                }
            });
        });
    };
    MuiDataTableGenerator.prototype.getColumnsDeclaration = function (sourceCode, tablePosition) {
        var result;
        var widgetParentNode = findWidgetParentNode(sourceCode, tablePosition);
        if (widgetParentNode) {
            var columnsDeclarationNode = this.findColumnsDeclaration(widgetParentNode);
            if (columnsDeclarationNode) {
                result = columnsDeclarationNode.getChildAt(2);
            }
        }
        return result;
    };
    MuiDataTableGenerator.prototype.printSourceCode = function (sourceFile) {
        var printer = ts.createPrinter({ newLine: ts.NewLineKind.LineFeed });
        return printer.printFile(sourceFile);
    };
    MuiDataTableGenerator.prototype.addNewColumn = function (columnDeclarationParent, property, ast, columnIndex) {
        var newColumnsDefinition = this.getNewColumnsDeclaration(columnDeclarationParent, property, columnIndex);
        return replaceElementsToAST(ast, columnDeclarationParent.pos, factory.createArrayLiteralExpression(newColumnsDefinition));
    };
    MuiDataTableGenerator.prototype.getNewColumnsDeclaration = function (columnDeclarationParent, property, columnIndex) {
        var newElements = [];
        var oldElements = columnDeclarationParent.elements;
        var newColumnDefinition = this.createColumnDefinition(property, this.getUsedFormatter(columnDeclarationParent));
        if (columnIndex && columnIndex > 0 && columnIndex < oldElements.length + 1) {
            newElements = __spreadArray(__spreadArray(__spreadArray([], oldElements.slice(0, columnIndex - 1)), [newColumnDefinition]), oldElements.slice(columnIndex - 1));
        }
        else {
            newElements = __spreadArray(__spreadArray([], oldElements), [newColumnDefinition]);
        }
        return newElements;
    };
    MuiDataTableGenerator.prototype.getUsedFormatter = function (columnsDefinition) {
        return columnsDefinition.elements.length === 0 ? Formatter.None
            : columnsDefinition.elements[0].properties.length > 3
                ? Formatter.ReactIntl
                : Formatter.None;
    };
    MuiDataTableGenerator.prototype.findColumnsDeclaration = function (widgetParent) {
        var array = [];
        findVariableDeclarations(widgetParent, array);
        if (array.length > 0) {
            var columnDeclaration = array.filter(function (def) {
                return def.getChildAt(0).getFullText().trim() === 'columns';
            });
            if (columnDeclaration && columnDeclaration.length > 0) {
                return columnDeclaration[0];
            }
        }
        return undefined;
    };
    MuiDataTableGenerator.prototype.generateTableComponent = function () {
        if (this._entity) {
            var statements = this.createStatements();
            var functionalComponent = createFunctionalComponent(getListComponentName(this._entity), [this._helper.createInputParameter(this._entity)], statements);
            this._imports = __spreadArray(__spreadArray([], this._imports), this._intlFormatter.getImports());
            var uniqueFileImports = uniqueImports(this._imports);
            uniqueFileImports.push(createNameSpaceImport('React', 'react'));
            return { functionDeclaration: functionalComponent, imports: uniqueFileImports };
        }
        else
            return undefined;
    };
    MuiDataTableGenerator.prototype.getTableDefinition = function () {
        return MuiDtTableComponents;
    };
    MuiDataTableGenerator.prototype.createStatements = function () {
        var statements = new Array();
        if (this._context.formatter === Formatter.ReactIntl) {
            statements.push(this._intlFormatter.getImperativeHook());
        }
        var columnsIdentifier = factory.createIdentifier("columns");
        var columnsDeclaration = this.createColumns(columnsIdentifier);
        var columnsAttribute = createJsxAttribute("columns", "columns");
        statements.push(factory.createVariableStatement(undefined, columnsDeclaration));
        var rowsAttribute = createJsxAttribute("rows", this._helper.getInputParameterIdentifier(this._entity));
        var returnStatement = this.createReturnStatement([columnsAttribute, rowsAttribute]);
        statements.push(returnStatement);
        return statements;
    };
    MuiDataTableGenerator.prototype.createReturnStatement = function (parameters) {
        var dataGridComponent = this._helper.prepareComponent(this.getTableDefinition().table, this._imports);
        var wrappedTable = this.createTableWrapper(createJsxSelfClosingElement(dataGridComponent.tagName, parameters));
        return factory.createReturnStatement(factory.createParenthesizedExpression(wrappedTable));
    };
    MuiDataTableGenerator.prototype.createTableWrapper = function (datagrid) {
        var _a, _b, _c;
        return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("div"), undefined, factory.createJsxAttributes([factory.createJsxAttribute(factory.createIdentifier("style"), factory.createJsxExpression(undefined, factory.createObjectLiteralExpression([
                factory.createPropertyAssignment(factory.createIdentifier("height"), factory.createStringLiteral((_c = (_b = (_a = this._context) === null || _a === void 0 ? void 0 : _a.index) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : "400px")),
                factory.createPropertyAssignment(factory.createIdentifier("width"), factory.createStringLiteral("100%"))
            ], false)))])), [
            factory.createJsxText("\
            ", true),
            datagrid,
            factory.createJsxText("\
          ", true)
        ], factory.createJsxClosingElement(factory.createIdentifier("div")));
    };
    MuiDataTableGenerator.prototype.createColumns = function (columnsIdentifier) {
        var _this = this;
        var propertiesColumnDefinitions = Array();
        getProperties(this._entity).forEach(function (property) {
            var _a;
            propertiesColumnDefinitions.push(_this.createColumnDefinition(property, (_a = _this._context.formatter) !== null && _a !== void 0 ? _a : Formatter.None));
        });
        return factory.createVariableDeclarationList([factory.createVariableDeclaration(columnsIdentifier, undefined, undefined, factory.createArrayLiteralExpression(propertiesColumnDefinitions, true))], ts.NodeFlags.Const);
    };
    MuiDataTableGenerator.prototype.createColumnDefinition = function (property, formatter) {
        var propertyName = property.getName();
        var propType = getPropertyType(property);
        var muiColumnType = 'string';
        //TODO: datetime is not working for numbers, find out why
        switch (propType) {
            case PropertyType.currency:
            case PropertyType.numeric:
                muiColumnType = 'number';
                break;
            case PropertyType.date:
            case PropertyType.datetime:
                muiColumnType = 'date';
                break;
        }
        var properties = [
            factory.createPropertyAssignment(factory.createIdentifier("field"), factory.createStringLiteral(propertyName)),
            factory.createPropertyAssignment(factory.createIdentifier("flex"), factory.createNumericLiteral(1)),
            factory.createPropertyAssignment(factory.createIdentifier("type"), factory.createStringLiteral(muiColumnType))
        ];
        if (formatter === Formatter.ReactIntl) {
            properties.push(factory.createPropertyAssignment(factory.createIdentifier("valueFormatter"), this.getValueFormatter(property)));
            properties.push(factory.createPropertyAssignment(factory.createIdentifier("renderHeader"), this.getHeaderRender(property)));
        }
        else {
            properties.push(factory.createPropertyAssignment(factory.createIdentifier("headerName"), factory.createStringLiteral(property.getName())));
        }
        var expression = factory.createObjectLiteralExpression(properties, false);
        return expression;
    };
    MuiDataTableGenerator.prototype.getHeaderRender = function (property) {
        var declaration = this._helper.addImportDeclaration('GridColParams', muiDataGrid);
        this._imports.push(declaration);
        var localizedProperty = this._intlFormatter.localizePropertyNameUsingTag(property, this._entity);
        return factory.createArrowFunction(undefined, undefined, [factory.createParameterDeclaration(undefined, undefined, undefined, factory.createIdentifier("params"), undefined, factory.createTypeReferenceNode(factory.createIdentifier("GridColParams"), undefined), undefined)], undefined, factory.createToken(ts.SyntaxKind.EqualsGreaterThanToken), factory.createParenthesizedExpression(localizedProperty));
    };
    MuiDataTableGenerator.prototype.getValueFormatter = function (prop) {
        return factory.createArrowFunction(undefined, undefined, [factory.createParameterDeclaration(undefined, undefined, undefined, factory.createObjectBindingPattern([factory.createBindingElement(undefined, undefined, factory.createIdentifier("value"), undefined)]), undefined, undefined, undefined)], undefined, factory.createToken(ts.SyntaxKind.EqualsGreaterThanToken), this._intlFormatter.formatPropertyUsingImperative(prop, factory.createIdentifier("value"), factory.createIdentifier("value")));
    };
    return MuiDataTableGenerator;
}());
export default MuiDataTableGenerator;
